import { useContext } from 'react';
import { AuthContext, LanguageContext } from './CreateContext';

export const useAuth = () => useContext(AuthContext)
export const useLanguage = () => useContext(LanguageContext)
